export const ERROR_FIELD = {
  isEmpty: 'Field is required',
  notEmptyInvalid: 'Value is incorrect',
  notInArray: 'Value not allowed',
  notInt: 'Value not integer',
  notUnique: 'Field not unique',
  bigDigit: 'Value is too big',
  notGreaterThanRegister: 'This field is required.',
  notGreaterThan: 'This value must be 0 or greater than 0.',
  stringLengthTooLong: 'String is too long.',
  stringLengthTooShort: 'String is too short.',
  stringLengthInvalid: 'Value is incorrect.',
  stringLengthTooLongName:
    'String is too long. Maximum length is 30 characters.',
  stringLengthTooShortName: 'String is too short.',
  stringLengthInvalidName:
    'Value is incorrect. Maximum length is 30 characters.',
  currentPasswordIsEmpty:
    'You need to input your current password to change password.',
  stringLengthTooLongPass:
    'Password is too long. Maximum length is 20 characters.',
  stringLengthTooLongMessage:
    'Please input a message less than 500 characters.',
  stringLengthTooLongMessage100:
    'Please input a message less than 100 characters.',
  stringLengthTooLongMessage1000:
    'Please input a message less than 1000 characters.',
  stringLengthTooShortPass:
    'Password is too short. Minimum length is 6 characters.',
  stringLengthInvalidPass: 'Password is incorrect.',
  incorrectPass: 'Password is incorrect.',
  regexNotMatchPhone: 'Phone number is wrong.',
  regexInvalidPhone: 'Phone number is wrong.',
  regexErrorousPhone: 'Phone number is wrong.',
  stringLengthTooLongPhone:
    'Phone number is too long. Maximum length is 30 characters.',
  stringLengthTooShortPhone: 'Phone number is too short.',
  stringLengthInvalidPhone: 'Phone number is incorrect.',
  emailAddressInvalid: 'Email address is incorrect.',
  emailAddressInvalidFormat: 'Email address is incorrect.',
  emailAddressInvalidHostname: 'Email address is incorrect.',
  emailAddressInvalidMxRecord: 'Email address is incorrect.',
  emailAddressInvalidSegment: 'Email address is incorrect.',
  emailAddressDotAtom: 'Email address is incorrect.',
  emailAddressQuotedString: 'Email address is incorrect.',
  emailAddressInvalidLocalPart: 'Email address is incorrect.',
  emailAddressLengthExceeded: 'Email address is incorrect.',
  hostnameCannotDecodePunycode: 'Email address is incorrect.',
  hostnameInvalid: 'Email address is incorrect.',
  hostnameDashCharacter: 'Email address is incorrect.',
  hostnameInvalidHostname: 'Email address is incorrect.',
  hostnameInvalidHostnameSchema: 'Email address is incorrect.',
  hostnameInvalidLocalName: 'Email address is incorrect.',
  hostnameInvalidUri: 'Email address is incorrect.',
  hostnameIpAddressNotAllowed: 'Email address is incorrect.',
  hostnameLocalNameNotAllowed: 'Email address is incorrect.',
  hostnameUndecipherableTld: 'Email address is incorrect.',
  hostnameUnknownTld: 'Email address is incorrect.',
  passMatch: "Passwords don't match",
  ac_incorrect:
    'Please select item from list or select "Other" value and enter your item',
  select_incorrect: 'Please select item from list',
  fileExtensionFalse: 'This type of file is not supported.',
  fileIsImageNotDetected: 'This type of file is not supported.',
  fileSizeTooBig: 'The file is too big. Max file size is 2MB.',
  filesUploadError: 'Check your files size. Max file size is 2MB.',
  bigFileSize: 'The file is too big. Max file size is 2MB.',
  fileUploadErrorIniSize: 'The file is too big. Max file size is 2MB.',
  exeFileNotAllowed: 'Executable files are not allowed.',
  fileIsImageNotDetectedCandidateFile: 'This type of file is not supported.',
  filesUploadErrorCandidateFile: 'Check your files size. Max file size is 2MB.',
  exeFileNotAllowedCandidateFile: 'Executable files are not allowed.',
  fileSizeTooBigCandidateFile: 'The file is too big. Max file size is 2MB.',
  bigFileSizeCandidateFile: 'The file is too big. Max file size is 2MB.',
  fileUploadErrorIniSizeCandidateFile:
    'The file is too big. Max file size is 2MB.',
  fileExtensionFalseCandidateFile: 'This type of file is not supported.',
  recordFoundEmail: 'Email is already in use.',
  regexNotMatchSat: 'Value is incorrect.',
  regexInvalidSat: 'Value is incorrect.',
  regexErrorousSat: 'Value is incorrect.',
  duplicateOther: '' /* no need to show message */,
  loginPassIncorrect: 'Incorrect login or password.',
  notApproved: 'Your account is not approved.',
  notConfirmed: 'Your should confirm your email to login.',
  emptyEmail: 'Enter your email.',
  unknownEmail: 'Unknown email.',
  recommendationMessageEmpty: 'Please input your recommendation.',
  unknownError: 'Unknown error. Please try again later.',
  fileIsImageFalseType: 'This type of file is not supported.',
  MessageEmptyText: 'Please enter text',
  MessageEmptyTo: 'Please enter recepient',
  MessageEmptySubject: 'Please enter subject',
  MessageLongSubject: 'Maximum subject length is 255 characters.',
  MessageEmptyHeader: 'Please enter header',
  MessageLongHeader: 'Maximum header length is 255 characters.',
  MessageLongSubheader: 'Maximum sub-header length is 255 characters.',
  MessageLongText: 'Maximum message length is 500 characters.',
  ManualMessageLongText: 'Maximum message length is 65536 characters.',
  MessageWrongReply: "Can't find message for reply",
  MessageRecipientNotFound: 'Recipient not found',
  selectRate: 'Select rate',
  incorrectDatePosition: 'Start date must be earlier than end date.',
  stringLengthTooLongRateNotes: 'Maximum notes length is 500 characters.',
  stringLengthTooShortRateNotes: 'Maximum notes length is 500 characters.',
  stringLengthInvalidRateNotes: 'Maximum notes length is 500 characters.',
  invalidCc: 'Email addres in CC is invalid',
  dateFalseFormat: 'Invalid date format',
  enterCurrentPass: 'Enter Current Password.',
  enterNewPass: 'Enter New Password.',
  enterConfirmPass: 'Enter Confirm Password.',
  selectDateAptitudeTest: 'Select dates for all checked tests.',
  selectAptitudeTest: 'Select at least one aptitude test for request.',
  inboundCompanyNotFound: 'Company not selected',
  inboundMessageIsEmpty: 'Message is empty',
  noInboundsLeft:
    'Purchase more InBounds to send your profile and resume to this firm.',
  recruiterNoRightEmail: "You don't have right to email candidates.",
  cannotAddBAPosition: "You can't add BA position.",
  questionLengthTooLong:
    'Question is too long. Maximum length is 300 characters.',
  answerLengthTooLong: 'Answer is too long. Maximum length is 300 characters.',
  noResumes: 'Selected candidates have no resumes.',
  stringLengthTooShort10:
    'String is too short. Minimum length is 10 characters.',
  stringLengthTooShort20:
    'String is too short. Minimum length is 20 characters.',
  PriorityNotValid: 'Priority is not valid. It should be between 1 and 100',
  appDeadlineDate: 'Application Deadline Date should be less than Start Date',
  multipleTestIncorrectId: 'Incorrect ID',
  multipleTestNameEmpty: 'Field is required',
  multipleTestNameTooLong:
    'String is too long. Maximum length is 500 characters.',
  multipleTestNameNotUnique: 'Test Name is not unique.',
  multipleTestActiveNotValid: 'Please select valid value.',
  multipleTestSortNotValid: 'Please select valid value.',
  multipleTestQIncorrectId: 'Incorrect Question ID',
  multipleTestQNameEmpty: 'Field is required',
  multipleTestQNameTooLong:
    'String is too long. Maximum length is 1000 characters.',
  multipleTestQNameNotUnique: 'Question is not unique.',
  multipleTestQActiveNotValid: 'Please select valid value.',
  multipleTestQEmptyAnswers: 'Enter at least 1 answer.',
  multipleTestQRightIncorrect: 'Please select valid "Right" value.',
  multipleTestQAnswerTooLong:
    'Answer Text is too long. Maximum length is 1000 characters.',
  multipleTestQRightCountIncorrect: 'You must specify only one right answer',
  multipleTestQTimeIncorrect:
    'Please set Time. Minimum value is 1, maximum is 7200',
  candidateAlreadyPassedNCTest:
    'You`ve already completed the GoBuyside Aptitude Test',
  stringLengthTooLongComment:
    'Text is too long. Maximum length is 500 characters.',
  stringLengthTooShortComment: 'Enter text please.',
  noCandidateData:
    'You can\'t set value "Yes" because there\'s no candidate data',
  fillRecruiterData: 'Please set recruiter data',
  minMustBeLessMax: 'Min value must be less than Max value',
  notUrl: 'Url is not valid',
  image80x40: 'Image resolution must be at least 80x40',
};

export default ERROR_FIELD;
